import { Injectable, ModuleWithProviders, NgModule } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Resolve } from '@angular/router';
import { SharedCommonModule, SharedComponentsModule, SharedFormModule } from '@spaq/shared';

import { Observable } from 'rxjs/index';
import { filter, take, tap } from 'rxjs/operators';
import { EmailUpdateComponent, PasswordUpdateComponent, ProfilUpdateComponent, UpdateSmsComponent } from './components';

@Injectable()
export class TeamResolver implements Resolve<Observable<any>> {
	constructor(private afAuth: AngularFireAuth) {}

	resolve() {
		return this.afAuth.authState.pipe(
			filter(x => !!x),
			take(1),
			tap(_x => {})
		);
	}
}

@NgModule({
	imports: [SharedCommonModule, SharedFormModule, SharedComponentsModule],
	declarations: [ProfilUpdateComponent, PasswordUpdateComponent, EmailUpdateComponent, UpdateSmsComponent],
	exports: [ProfilUpdateComponent, PasswordUpdateComponent, EmailUpdateComponent, UpdateSmsComponent],
	entryComponents: [ProfilUpdateComponent, PasswordUpdateComponent, EmailUpdateComponent, UpdateSmsComponent]
})
export class UserModule {
	static forRoot(): ModuleWithProviders<UserModule> {
		return {
			ngModule: UserModule,
			providers: []
		};
	}

	constructor() {}
}
